import { serverUrl } from './serverConfig'
import { genericError } from "../util/errorUtil"
export const getplayersApi = async (sessionToken) => {
    try {
        const body = {
            "identity": "user.aca.getplayers",
        }
        const allPlayers = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await allPlayers.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}

export const getplayersWithPaginationApi = async (sessionToken, limit, startDateTs) => {
    try {
        var body = {
            "identity": "user.aca.getplayers",
            "limit": limit,
        }
        if (startDateTs !== 0) {
            body.startDateTs = startDateTs
        }
        const allPlayers = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await allPlayers.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}

export const assignCoachToPlayerApi = async (payload) => {
    try {
        const { playerUid, coachUid, sessionToken } = payload.payload
        console.log("playerUid : " + playerUid)
        const body = {
            "identity": "user.aca.assigncoach",
            "playerUid": playerUid,
            "coachUid": coachUid,
        }
        const player = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await player.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}

export const changeCoachToPlayerApi = async (payload) => {
    try {
        const { playerUid, coachUid, newCoachUid, sessionToken } = payload.payload
        console.log("playerUid : " + playerUid)
        const body = {
            "identity": "user.aca.replacecoach",
            "playerUid": playerUid,
            "coachUid": coachUid,
            "newCoachUid": newCoachUid
        }
        const player = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await player.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}

export const removeCoachToPlayerApi = async (payload) => {
    try {
        const { playerUid, coachUid, sessionToken } = payload.payload
        console.log("playerUid : " + playerUid)
        const body = {
            "identity": "user.aca.removecoach",
            "playerUid": playerUid,
            "coachUid": coachUid,
        }
        const player = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await player.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}